var _path, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgImgPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 588,
  height: 802,
  viewBox: "0 0 588 802",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M99 28C101.209 28 103 29.7909 103 32V38C103 40.2091 101.209 42 99 42H32C29.7909 42 28 40.2091 28 38V32C28 29.7909 29.7909 28 32 28H99Z",
  fill: "black",
  fillOpacity: 0.1
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M45.9997 60C36.0589 60 28 68.059 28 77.9998C28 87.9404 36.0589 96 45.9997 96C55.9405 96 64 87.9404 64 77.9998C64 68.0588 55.9405 60 45.9997 60Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157 71C159.209 71 161 72.7909 161 75V81C161 83.2091 159.209 85 157 85H80C77.7909 85 76 83.2091 76 81V75C76 72.7909 77.7909 71 80 71H157Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M501 84C503.209 84 505 85.7909 505 88V98C505 100.209 503.209 102 501 102H232C229.791 102 228 100.209 228 98V88C228 85.7909 229.791 84 232 84H501Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564 61C566.209 61 568 62.7909 568 65V75C568 77.2091 566.209 79 564 79H232C229.791 79 228 77.2091 228 75V65C228 62.7909 229.791 61 232 61H564Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328 168C330.209 168 332 169.791 332 172V176C332 178.209 330.209 180 328 180H232C229.791 180 228 178.209 228 176V172C228 169.791 229.791 168 232 168H328Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M395 145C397.209 145 399 146.791 399 149V155C399 157.209 397.209 159 395 159H232C229.791 159 228 157.209 228 155V149C228 146.791 229.791 145 232 145H395Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M501 127C503.209 127 505 128.791 505 131V137C505 139.209 503.209 141 501 141H232C229.791 141 228 139.209 228 137V131C228 128.791 229.791 127 232 127H501Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460 109C462.209 109 464 110.791 464 113V119C464 121.209 462.209 123 460 123H232C229.791 123 228 121.209 228 119V113C228 110.791 229.791 109 232 109H460Z",
  fill: "black"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M45.9997 222C36.0589 222 28 230.059 28 240C28 249.94 36.0589 258 45.9997 258C55.9405 258 64 249.94 64 240C64 230.059 55.9405 222 45.9997 222Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157 233C159.209 233 161 234.791 161 237V243C161 245.209 159.209 247 157 247H80C77.7909 247 76 245.209 76 243V237C76 234.791 77.7909 233 80 233H157Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M501 246C503.209 246 505 247.791 505 250V260C505 262.209 503.209 264 501 264H232C229.791 264 228 262.209 228 260V250C228 247.791 229.791 246 232 246H501Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564 223C566.209 223 568 224.791 568 227V237C568 239.209 566.209 241 564 241H232C229.791 241 228 239.209 228 237V227C228 224.791 229.791 223 232 223H564Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328 330C330.209 330 332 331.791 332 334V338C332 340.209 330.209 342 328 342H232C229.791 342 228 340.209 228 338V334C228 331.791 229.791 330 232 330H328Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M395 307C397.209 307 399 308.791 399 311V317C399 319.209 397.209 321 395 321H232C229.791 321 228 319.209 228 317V311C228 308.791 229.791 307 232 307H395Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M501 289C503.209 289 505 290.791 505 293V299C505 301.209 503.209 303 501 303H232C229.791 303 228 301.209 228 299V293C228 290.791 229.791 289 232 289H501Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460 271C462.209 271 464 272.791 464 275V281C464 283.209 462.209 285 460 285H232C229.791 285 228 283.209 228 281V275C228 272.791 229.791 271 232 271H460Z",
  fill: "black"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M45.9997 384C36.0589 384 28 392.059 28 402C28 411.94 36.0589 420 45.9997 420C55.9405 420 64 411.94 64 402C64 392.059 55.9405 384 45.9997 384Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157 395C159.209 395 161 396.791 161 399V405C161 407.209 159.209 409 157 409H80C77.7909 409 76 407.209 76 405V399C76 396.791 77.7909 395 80 395H157Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M501 408C503.209 408 505 409.791 505 412V422C505 424.209 503.209 426 501 426H232C229.791 426 228 424.209 228 422V412C228 409.791 229.791 408 232 408H501Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564 385C566.209 385 568 386.791 568 389V399C568 401.209 566.209 403 564 403H232C229.791 403 228 401.209 228 399V389C228 386.791 229.791 385 232 385H564Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328 434C330.209 434 332 435.791 332 438V442C332 444.209 330.209 446 328 446H232C229.791 446 228 444.209 228 442V438C228 435.791 229.791 434 232 434H328Z",
  fill: "black"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M45.9997 476C36.0589 476 28 484.059 28 494C28 503.94 36.0589 512 45.9997 512C55.9405 512 64 503.94 64 494C64 484.059 55.9405 476 45.9997 476Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157 487C159.209 487 161 488.791 161 491V497C161 499.209 159.209 501 157 501H80C77.7909 501 76 499.209 76 497V491C76 488.791 77.7909 487 80 487H157Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M501 500C503.209 500 505 501.791 505 504V514C505 516.209 503.209 518 501 518H232C229.791 518 228 516.209 228 514V504C228 501.791 229.791 500 232 500H501Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564 477C566.209 477 568 478.791 568 481V491C568 493.209 566.209 495 564 495H232C229.791 495 228 493.209 228 491V481C228 478.791 229.791 477 232 477H564Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328 526C330.209 526 332 527.791 332 530V534C332 536.209 330.209 538 328 538H232C229.791 538 228 536.209 228 534V530C228 527.791 229.791 526 232 526H328Z",
  fill: "black"
}))));
export default SvgImgPlaceholder;